module.exports = __webpack_public_path__ + "img/wishlist-empty.c83585e1.svg";